import contactsModule from '../contactsModule';

function aliasController() {
    "ngInject";
};

contactsModule.controller('aliasController', aliasController);

export default aliasController; 